import {
  cta_buttonPrimaryBackground,
  text_colorTextPrimary,
  text_colorTextSecondary,
  warning_border,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md, fontH3, fontRegular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.VirtualCardTypePicker {
    .no-rcns-empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: ${spacing(12)} 0;
    }

    .no-rcns-title {
      ${fontH3};
      color: ${text_colorTextPrimary};
      margin-top: ${spacing(5)};
    }

    .no-rcns-body {
      ${font_md};
      color: ${text_colorTextSecondary};
      margin-top: ${spacing(3)};
    }

    .alert-text {
      ${fontRegular};
      color: ${text_colorTextPrimary};
    }
    .card-type-box {
      &:nth-child(n + 2) {
        margin-top: ${spacing(5)};
      }
    }

    .card-type-box-org-disabled {
      border: 1px solid ${warning_border};
    }

    .declining-balance-box,
    .issuer-cycle-box {
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: box-shadow 50ms ease-out;

      &:hover {
        box-shadow:
          0 1px 5px 0 rgba(0, 0, 0, 0.15),
          inset 0px 0px 0px 1px var(--color-cta);
      }

      &.disabled {
        opacity: 50%;
        cursor: default;

        &:hover {
          box-shadow: none;
        }
      }
    }

    .declining-balance-image,
    .issuer-cycle-image {
      flex-shrink: 0;
    }

    .declining-balance-text,
    .issuer-cycle-text {
      display: flex;
      flex-direction: column;
      margin-left: ${spacing(8)};
    }

    .declining-balance-title,
    .issuer-cycle-title {
      ${fontH3};
      color: ${cta_buttonPrimaryBackground};
      display: flex;
      align-items: center;
      margin-bottom: ${spacing(2)};
    }

    .declining-balance-subtitle,
    .issuer-cycle-subtitle {
      ${fontRegular};
      color: ${text_colorTextPrimary};
    }

    .vendor-section-header {
      display: flex;
      align-items: center;
      margin-top: ${spacing(10)};
      font-size: 14px;
      color: ${text_colorTextSecondary};
    }

    .alert-with-budgets {
      margin-bottom: ${spacing(5)};
    }

    .alert-without-budgets-text {
      margin-top: ${spacing(5)};
    }

    .alert-without-budgets-button-container {
      display: flex;
    }

    .alert-without-budgets-button {
      margin-top: ${spacing(5)};
    }
  }
`
